// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"highlight"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M19 15H15V19M15.8839 15.8839L20 20","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M8.5 3H9.5M13.5 3H14.5M8.5 20H9.5M20 8.5V9.5M3 8.5V9.5M3 13.5V14.5M4.5 3H3V4.5M4.5 20H3V18.5M18.5 3H20V4.5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-highlight')
export default class HighlightIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'highlight',
    }
  }
}
